import { gql } from '@apollo/client';


export default gql`
    query deliveryDates(
        $period: String!,
        $trial_scenario: trialScenario,
        $filters_modified: Boolean,
        $ignore_period: Boolean,
    ) {
        deliveryDates(
            period: $period,
            trial_scenario: $trial_scenario,
            filters_modified: $filters_modified,
            ignore_period: $ignore_period,
        ) {
            available_dates
            disabled_dates
            availableDates @client {
                id,
                date,
            }
        }
    }
`;
